import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

import { ICompanyMast } from "../../models/CompanyMast";

import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { baseUrl, Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { ICityMastDropdown, ICompanyMastDropdown, IStateMastDropdown } from "../../models/IDropdown";
import { JVDropdownInput } from "../../shared/JVDropdownInput";
import { EmptyCompany } from "./EmptyCompany";
import { Editor } from "primereact/editor";
import { JVCheckbox } from "../../shared/JVCheckbox";
import { JVDropdown } from "../../shared/JVDropdown";
import { ILogin } from "../../models/Login";
import { FileUpload } from "primereact/fileupload";
import { JVInputMask } from "../../shared/JVInputMask";



const schema = yup.object({
    company_Name: yup.string().required("Company Name is required*").min(3),
    company_Address: yup.string().required("Address is required*").min(3),
    city: yup.object().shape({
        city_ID: yup.number().min(1, "City is required*").required("City is required*"),
        city_Name: yup.string().required()
    }),
    state: yup.object().when('job_Type', val => {
        return (val === "Remote") ?
            yup.object().nullable() :
            yup.object().shape({
                state_ID: yup.number().min(1, "State is required*").required("State is required*"),
                state_Name: yup.string().required()
            })
    }),
    company_Zip: yup.string().required("ZIP Code is required*").matches(/^[a-zA-Z0-9-]*$/, "ZIP Code must be alphanumeric").max(10, "ZIP Code cannot exceed 10 characters"),
    company_Domain: yup.string().required("Company Domain is required").matches(/^(?!https?:\/\/)[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        "Enter a valid domain like abc.com (Do not include http:// or https://)"),
    send_From_Title: yup.string().required("Send From Title is required"),
    is_Other_Company: yup.boolean().nullable(),
    recruitment_Company_ID: yup.number().when('Is_Other_Company', val => {
        return (val === true) ?
            yup.number().required("company is required").typeError("company is required") :
            yup.number().nullable();
    }),
    feid: yup.string().required("Federal ID Number is required*").matches(/^\d{2}-\d{7}$/, "Federal ID Number must be in the format 00-0000000"),
    accounts_Email: yup.string().required("Accounts Email is required"),
    accounts_Contact: yup.string().required("Accounts Contact is required"),
    allocate_By_Team: yup.boolean().nullable(),
    allocation_Count: yup.number().when('allocate_By_Team', val => {
        return (val === true) ?
            yup.number().required("Allocation Count is required").typeError("Allocation Count is required") :
            yup.number().nullable();
    }),
});

interface Iprops {
    singleData: ICompanyMast,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void
}

export const Form = (props: Iprops) => {
    const [cities, setCities] = useState<Array<ICityMastDropdown>>();
    const [disclaimer, setDisclaimer] = useState("");
    const [companies, setCompanies] = useState<Array<ICompanyMastDropdown>>();
    const [isCompany, setIsCompany] = useState(false);
    const [companyLogo, setCompanyLogo] = useState<File | null>(null);
    const [states, setStates] = useState<Array<IStateMastDropdown>>();
    const [showAllocationCount, setShowAllocationCount] = useState<boolean>(false);

    const { control, handleSubmit, formState: { errors }, reset, watch } = useForm<ICompanyMast>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });

    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    useEffect(() => {
        reset(props.singleData);
        props.singleData.disclaimer ? setDisclaimer(props.singleData.disclaimer) : setDisclaimer("");
    }, [props.singleData])

    const loadCities = async (filter: string | null) => {
        if (control._formValues.state?.state_ID) {
            const response = await Fetch("Dropdown/cities", "GET", null, `filter=${filter}&state_id=${control._formValues.state.state_ID}`, null);
            if (response) {
                const data: Array<ICityMastDropdown> = await response.json();
                setCities(data);
            }
        } else {
            props.toast.current.show({ severity: 'error', detail: "Select the State First.", life: 3000 });
        }
    }

    const loadCompanies = async () => {
        let endPoint = loginObj.id === 1346 ? "company" : "reqCompanyList";

        const response = await Fetch(`Dropdown/${endPoint}`, "GET", null, null, null);
        if (response) {
            const data: Array<ICompanyMastDropdown> = await response.json();
            const emptyData = {
                company_ID: 0,
                company_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setCompanies(data);
        }
    }

    useEffect(() => {
        loadCompanies();
    }, []);
    useEffect(() => {
        reset(props.singleData);
        if (props.singleData.is_Other_Company) {
            setIsCompany(true);
            if (props.singleData.company_ID) loadCompanies();
        }

        if (props.singleData?.allocate_By_Team === true) {
            setShowAllocationCount(true);
        }

    }, [props.singleData]);
    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "is_Other_Company") {
                if (value.is_Other_Company === true) setIsCompany(true);
                else setIsCompany(false);
            }

            if (name === 'allocate_By_Team') {
                if (value.allocate_By_Team === true) {
                    setShowAllocationCount(true);
                } else setShowAllocationCount(false);
            }
        });
        return () => subscription.unsubscribe();
    }, [watch, showAllocationCount]);



    const completeMethod = (event: { query: string }) => {
        loadCities(event.query);
    }

    // const saveToDB = async (body: ICompanyMast, event: any) => {
    //     if (body.is_Other_Company === false && (body.recruitment_Company_ID != undefined || body.recruitment_Company_ID != null)) body.recruitment_Company_ID = null;
    //     if (body.is_Other_Company === true && body.recruitment_Company_ID === 0) {
    //         props.toast.current.show({ severity: 'error', detail: "Please select a company", life: 3000 });
    //     } else {
    //         const method = props.singleData.company_ID ? "PUT" : "POST";
    //         const message = props.singleData.company_ID ? "Updated Successfully" : "Added Successfully";

    //         body.company_City = body.city?.city_ID;
    //         delete body.city;


    //         const response = await Fetch("Company_Mast", method, body, null, props.toast);
    //         if (response) {
    //             props.hideDialog();
    //             props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
    //             props.setReload(!props.reload);
    //         }
    //     }
    // }


    const onHide = () => {
        setShowAllocationCount(false);
        reset(EmptyCompany);
        props.hideDialog();
        setIsCompany(false);
    }

    const onSubmit = async (data: ICompanyMast, event: any) => {
        data.disclaimer = disclaimer;

        if (data.is_Other_Company === false && (data.recruitment_Company_ID != undefined || data.recruitment_Company_ID != null)) {
            data.recruitment_Company_ID = null;
        }

        if (data.is_Other_Company === true && data.recruitment_Company_ID === 0) {
            props.toast.current.show({ severity: 'error', detail: "Please select a company", life: 3000 });
            return;
        }

        const method = props.singleData.company_ID ? "PUT" : "POST";
        const message = props.singleData.company_ID ? "Updated Successfully" : "Added Successfully";

        data.company_City = data.city?.city_ID;
        delete data.city;
        data.company_State = data.state?.state_ID;
        delete data.state;

        if (data.allocate_By_Team !== true) {
            data.allocation_Count = 0;
        }

        try {
            const formData = new FormData();
            if (companyLogo) {
                formData.append("companyLogo", companyLogo);
            }
            formData.append("data", JSON.stringify(data));


            const response = await fetch(`${baseUrl}Company_Mast`, {
                method,
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("auth") + "")?.token
                        }`
                },
                body: formData,
            });

            if (response.ok) {
                reset(EmptyCompany);
                props.hideDialog();
                props.toast.current.show({ severity: "success", detail: message, life: 3000 });
                props.setReload(!props.reload);
            } else {
                console.error("Error submitting data:", response.statusText);
            }
        } catch (error) {
            console.error("Error:", error);
        }
    }

    const completeMethodStates = (event: { query: string }) => {
        loadStates(event.query);
    }
    const loadStates = async (filter: string | null) => {
        const response = await Fetch("Dropdown/states", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IStateMastDropdown> = await response.json();
            setStates(data);
        }
    }

    const companyLogoUpload = (event: any) => {
        const file = event.files[0];
        setCompanyLogo(file);
        props.toast.current.show({ severity: 'success', summary: 'Success', detail: "Certificate Selecetd", life: 3000 });
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit Company" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">

                <JVInput column={2} required label="Company Name" control={control} name="company_Name" error={errors.company_Name?.message} />
                <JVInput required column={2} label="FEID" control={control} name="feid" error={errors.feid?.message} />

                <JVInput column={2} required label="Address" control={control} name="company_Address" error={errors.company_Address?.message} />
                <JVInput column={2} required label="Accounts Email" control={control} name="accounts_Email" error={errors.accounts_Email?.message} />
                <JVInputMask column={2} mask="(999) 999-9999" required label="Accounts Phone No." control={control} name="accounts_Contact" error={errors.accounts_Contact?.message} />
                <JVDropdownInput required column={3} completeMethod={completeMethodStates} label="State" control={control} name="state" error={errors.state?.state_ID?.message} options={states} optionLabel="state_Name" placeholder="Search State" />
                <JVDropdownInput required column={4} completeMethod={completeMethod} label="City" control={control} name="city" error={errors.city?.city_ID?.message} options={cities} optionLabel="city_Name" placeholder="Search City" />
                <JVInput required label="Zip Code" column={4} control={control} name="company_Zip" error={errors.company_Zip?.message} />
                <JVInput label="Website URL" required column={2} control={control} name="company_Domain" error={errors.company_Domain?.message} />
                <div className='mt-4 ml-2'>
                    <FileUpload mode="basic" name="Company_Logo" chooseLabel="Upload Company Logo" auto customUpload uploadHandler={companyLogoUpload} />
                </div>
                <div style={{ margin: '10px 0', width: '100%' }}></div>
                <JVInput name="send_From_Title" required control={control} label="Send From Title" error={errors.send_From_Title?.message} />
                <div style={{ margin: '10px 0', width: '100%' }}></div>
                <JVCheckbox control={control} name="is_Other_Company" label="Recruiment From Other Company" />
                {isCompany && <JVDropdown name="recruitment_Company_ID" required control={control} options={companies} optionLabel="company_Name" optionValue="company_ID" placeholder="Select Company" error={errors.recruitment_Company_ID?.message} />}
                <JVCheckbox control={control} name="allocate_By_Team" label="Allocation Team Wise" />
                {showAllocationCount && <JVInput name="allocation_Count" required control={control} label="Allocation Count" error={errors.allocation_Count?.message} />}
                <div className="col-12 md:col-12 md:col-6">
                    <label htmlFor="disclaimer">Disclaimer</label>
                    <Editor style={{ height: '25vh' }} value={disclaimer} onTextChange={(e) => { if (e.htmlValue) setDisclaimer(e.htmlValue) }} />
                </div>
                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button style={{ width: '100px' }} label="SAVE" type="submit"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-outlined surface-200		"></Button>
                </div>

            </form>
        </Dialog>
    );
}
